import React from "react";
import Heading from "../Heading/Heading";
import ResumeTips from "../ResumeTips/ResumeTips";
import styles from "./SectionHeading.module.css";

function SectionHeading(props) {
  return (
    <>
      <Heading key={props.section || props.content} section={props.section} editable={props.editable} content={props.content} />
      <ResumeTips section={props.section} className={props.editable ? styles['ml-12'] : styles['ml-4']}/>
      {props.subheading && (
        <p className={styles.subheading}>{props.subheading}</p>
      )}
    </>
  );
}

export default SectionHeading;
